import { cloneDeep, isArray, isNumber } from 'lodash';
import { adapterConfig } from '../config';

/**
 * 适配调整系数
 *
 * @param args - 参数
 */
export function adapterEnhanceArgs(args: any) {
    const res: any = cloneDeep(args);
    for (const mKey in res) {
        if (!adapterConfig[mKey]) continue;

        if (Object.prototype.hasOwnProperty.call(res, mKey)) {
            const obj = res[mKey];
            for (const key in obj) {
                if (!adapterConfig[mKey][key]) continue;
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    const val = obj[key];
                    const valConfig = adapterConfig[mKey][key];
                    if (isNumber(val)) {
                        obj[key] = val * valConfig;
                    } else if (isArray(val)) {
                        val.forEach((v, i) => {
                            obj[key][i] = v * valConfig[i];
                        });
                    }
                }
            }
        }
    }
    return res;
}

export function formatExtractColors(colors: number[]): string[] {
    const rgbaCount = colors.length / 4;
    const result: string[] = [];
    for (let i = 0; i < rgbaCount; i++) {
        const [r, g, b, a] = colors.slice(i * 4, i * 4 + 4);
        // result.push(rgbaToHex({ r, g, b, a }));
        result.push(`rgba(${r},${g},${b},${a})`);
    }
    return result;
}
